<template>
    <div class="takers-selector">

        <global-view style="margin-top: 48.45px;margin-right: 40px;"></global-view>
        <div class="right-part">
            <div class="title-icons">
                <el-button
                    type="text"
                    icon="el-icon-arrow-left"
                    class="return-to-entity"
                    @click="$router.push('/')"
                >ENTITIES</el-button>
                <h1>Takers</h1>
                <h6>choose which taker to impersonate</h6>
            </div>
            <div class="takers-container">
                <div
                    v-for="taker in $store.getters.takers"
                    :key="taker.uid"
                    class="gcmcn-card"
                >
                    <div @click="setTaker(taker)">{{ taker.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalView from '../Home/global-view.vue';
export default {

    components: {
        GlobalView,
    },

    props: {

    },

    data (){
        return {
        };
    },

    computed: {
    },

    created (){
        this.$store.commit('REMOVE_CURRENT_TAKER');
    },

    methods: {
        setTaker(taker){
            this.$store.commit('SET_CURRENT_TAKER', taker);
            this.$store.dispatch('fetchTakerCurrentGroup').then(() => this.$router.push('/feed'));
        }
    },
};
</script>

<style lang="scss">
.takers-selector{
    position: absolute;
    z-index: 0;
    margin-left: 140px;
    display: flex;

    .right-part{
        width: 680px;
    }

    @media screen and (max-width: 1024px) {
        .taker-selector{
            margin-left: 0px;
        }
    }
    .return-to-entity{
        color: #bbb;
    }
    .gcmcn-card{
        min-height: 75px;
        margin-bottom: 15px;
        font-size: 30px;
        text-transform: uppercase;
        cursor: pointer;
    }
    .title-icons{
        color: #bbb;
        text-transform: uppercase;
        h1 {
            font-size: 30px;
        }
    }
    .takers-container{
        margin-top: 10px;
        height: calc(100vh - 110px);
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/TakerSelector/index.vue